import { Disableable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';

export type LinkVariant = 'default' | 'basic';

export enum LinkState {
    Disabled = 'disabled',
    Inherit = 'inherit',
    Inline = 'inline',
    Standalone = 'standalone',
}

export interface LinkProps extends Disableable, React.AnchorHTMLAttributes<HTMLAnchorElement> {
    as?: React.ElementType;
    children?: React.ReactNode;
    inherit?: boolean;
    overflowWrap?: 'normal' | 'break-word';
    size?: 'normal' | 'small';
    standalone?: boolean;
    /*
     * ACCESSIBILITY WARNING: Inline links (non-standalone) without underlines are not accessible
     * and should not be used. Always use underlines for inline links to ensure proper visual
     * identification for all users.
     *
     * @default true
     */
    underline?: boolean;
    wordBreak?: 'break-all' | 'break-word' | 'normal';
    variant?: LinkVariant;
    icon?: IconName;
    strong?: boolean;
}
